import React, {useEffect, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import {item as itemMedical, setMedical as setMedicalData, remove} from '../../../lib/api/medical';
import {item} from "../../../lib/api/player";
import {toast} from "react-toastify";
import IconButton from 'components/common/IconButton';

export function AddMedical({ player_guid, onClose, onSave }) {
    const _player_guid= player_guid;
    console.log('player_guid 01',player_guid)
    const [medical, setMedical] = useState(null);
    const [edit, setEdit] = useState(false);
    const [player, setPlayer] = useState({});
    const [errors, setErrors] = useState({
        medical_record: false,
        document: false
    });

    useEffect(() => {
        (async () => {
            const resMedical = await itemMedical(_player_guid);
            setMedical(resMedical.length>0 ? resMedical[0] : {});
            setEdit(resMedical.length>0);
            const resPlayer= await item({player_guid:_player_guid});
            setPlayer(resPlayer);
        })();
    }, [_player_guid]);

    const handleSubmit = async event => {
        event.preventDefault();

        if (!validateForm(event)) return;

        const form = event.currentTarget;
        const _data = {
            medical_record: medical.medical_record,
            document: form.document.files[0]
        };

        try {
            await setMedicalData(_data, _player_guid);
            onSave();
            onClose();
        }catch (err){
            toast.error(
                <span>
                    <p>Došlo je do greške.</p>
                    <p>{err.body?.message || err.message}</p>
                </span>
            );
        }
    };

    const handelOpen = (document) => {
        window.open(process.env.REACT_APP_BASE_API_URL + `/uploads/${document}`, '_blank');
    }

    const handelDelete = async season_medical_guid => {
        if (confirm(`Da li ste sigurni da želite ljekarsko uvjerenje?`)) {
            try {
                await remove(season_medical_guid);
                const resMedical = await itemMedical(_player_guid);
                setMedical(resMedical.length>0 ? resMedical[0] : {});
                setEdit(resMedical.length>0);
            }catch (err){
                toast.error(
                    <span>
                    <p>Došlo je do greške.</p>
                    <p>{err.body?.message || err.message}</p>
                </span>
                );
            }
        }
    }

    const validateForm = event => {
        const form = event.currentTarget;
        console.log('medical.document',medical.document)
        const newErrors = {
            medical_record: medical.medical_record !== 1,
            document: !medical.document
        };
        setErrors(newErrors);

        if (Object.values(newErrors).some(error => error)) {
            event.stopPropagation();
            return false;
        }
        return true;
    };

    return (
        <Card>
            <Card.Body className="bg-light">
                <Form
                    method="PUT"
                    encType="multipart/form-data"
                    noValidate
                    onSubmit={handleSubmit}
                >
                    <Row className="mb-3">
                        <Form.Group as={Col} md="7" controlId="compensation">
                            <Col md="12">
                                <Form.Check
                                    inline
                                    type="checkbox"
                                    id="medical_record"
                                    label="Prilažem zdravstveno uvjerenje"
                                    name="medical_record"
                                    onChange={e => setMedical({ ...medical, medical_record: e.target.checked ? 1 : 0 })}
                                    checked={medical?.medical_record || false}
                                    disabled={medical?.medical_record}
                                />
                                {errors.medical_record && (
                                    <div className="text-danger small mt-0">Morate izabrati da prilažete ljekarsko uvjerenje.</div>
                                )}
                            </Col>

                        </Form.Group>
                    </Row>
                    {!edit ? (
                        <>
                    <Row className="mb-5">
                        <Form.Group controlId="document">
                            <Form.Label>Izaberi dokument</Form.Label>
                            <Form.Control
                                type="file"
                                name="document"
                                onChange={e =>
                                    setMedical({ ...medical, document: e.target.files[0] })
                                }
                                isInvalid={errors.document}
                            />
                            {errors.document && (
                                <div className="text-danger small mt-3">Molimo izaberite dokument.</div>
                            )}
                        </Form.Group>
                    </Row>
                        <Button type="submit">Sačuvaj</Button>
                        </>
                        ):
                        <Row className="m-3">
                            <Col md="8">
                                <IconButton
                                    className="me-2 mb-1"
                                    variant="falcon-default"
                                    transform="shrink-3"
                                    icon="external-link-alt"
                                    onClick={() => handelOpen(medical.document_path)}
                                >
                                    Pregled ljekarskog uvjerenja
                                </IconButton>
                            </Col>
                            <Col md="4"  className="text-end">
                                <IconButton
                                    className="me-2 mb-1"
                                    variant="falcon-default"
                                    icon="trash"
                                    transform="shrink-3"
                                    onClick={() => handelDelete(medical.season_medical_guid)}
                                >
                                </IconButton>
                            </Col>

                        </Row>
                    }


                </Form>
            </Card.Body>
        </Card>
    );
}
